// extracted by mini-css-extract-plugin
export default {"happy":"FeedbackCard_happy__a0bk4","acceptable":"FeedbackCard_acceptable__iYdVd","unhappy":"FeedbackCard_unhappy__jsG3k","orderBox":"FeedbackCard_orderBox__uEZ8c"};